import { render } from "./AddOrganization.vue?vue&type=template&id=0bdf5726&scoped=true"
import script from "./AddOrganization.vue?vue&type=script&lang=js"
export * from "./AddOrganization.vue?vue&type=script&lang=js"

import "./AddOrganization.vue?vue&type=style&index=0&id=0bdf5726&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdf5726"],['__file',"src/views/UserManagement/OrganizationManagement/components/AddOrganization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bdf5726"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bdf5726', __exports__)) {
    api.reload('0bdf5726', __exports__)
  }
  
  module.hot.accept("./AddOrganization.vue?vue&type=template&id=0bdf5726&scoped=true", () => {
    api.rerender('0bdf5726', render)
  })

}


export default __exports__